export class TableException extends Error {}
